import { Pipe, PipeTransform } from '@angular/core';
import ArabicsObject from '../misc/data/arabics.json';

@Pipe({
  name: 'translator',
  standalone: true,
})
export class TranslatorPipeStandAlone implements PipeTransform {
  transform(key: string): string {
    let obj: any = ArabicsObject;
    if (key) {
      let arabic = obj[key];
      return !arabic ? key : arabic;
    }
    return key;
  }
}
